<template>
  <div class="camp">
    <div class="top-content">
      <div class="wdd">
        <p class="top-tip">2020夏季和2021冬季营地项目报名通道已开启！！</p>
        <div class="carousel">
           <img src="@/assets/campDetail/c1.png"
                    alt="" />
            <div class="word">
                <h1>少儿编程智造发明家营</h1>
                <h3>@清远田野绿世界</h3>
                <Row class="msg" type="flex" justify="space-between">
                  <i-col span="7">
                    课程消息
                      <!-- <AnchorLink href="#basic_usage" title="课程消息" /> -->
                  </i-col>
                  <i-col span="7">
                    营地情况
                    <!-- <AnchorLink href="#camp_state" title="营地情况" /> -->
                  </i-col>
                  <i-col span="7">
                    关于我们
                    <!-- <AnchorLink href="#about_us" title="关于我们" /> -->
                  </i-col>
              </Row>
            </div>
        </div>
      </div>
    </div>
    <div class="explain">
      <svg-icon class="wave"
                icon-class="camp1"></svg-icon>
    </div>
    <div id="basic_usage">
      <div class="world">
        <Row class="word-content">
          <i-col span="12">
            <iframe src="" frameborder="0"></iframe>
          </i-col>
          <i-col span="12">
            <h1>智造发明家营@清远田野绿世界</h1>
            <p>在智造发明家营，我们将带领营员前往拥有原始生态环境的清远市，共同感受创客科技与户外生态自然的有机融合</p>
            <p>在营期的开启阶段，营地导师将带领营员感知田野绿世界营地的原生态环境，并熟知营地的基本规则，同时开始初步了解mBot机器人青少年比赛的规则和器材的应用。</p>
            <p>在营期中段，营员将从mBot机器人基础机械机构开始，熟悉了解其基础编程、实际操控和调试设备等各环节，并开始自主设计匹配赛道的功能。</p>
            <p>营期的最后环节，营员将全体集合并综合调试实现mBot比赛赛道规则，最后由专业竞赛导师进行点评和改善意见。</p>
            <a class="connact-report" href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
        </Row>
        <div class="logo">
          <img src="@/assets/insideCamp/l1.png"
               alt="" />
        </div>
        <Row class="introduce" type="flex" justify="space-between">
          <i-col span="11" style="text-align: right">
            <p>年龄： 6-12岁</p>
            <p>辅导员配比： 5：1</p>
            <p>硬件+软件： mBot，Parrot，慧编程</p>
          </i-col>
          <i-col span="11" style="text-align: left">
            <p>营地日期： 5天4夜</p>
            <p>营地地点：清远田野绿世界</p>
            <p>已报人数：16/20</p>
          </i-col>
        </Row>
      </div>
      <div class="wd">
        <p class="item-title">课程信息</p>
        <p class="small-title">和我们一起来感受STEAM创客和PBL的创作乐趣吧</p>
        <Row class="course-msg" type="flex" justify="center">
          <i-col span="12" style="text-align: center">
            <img class="u1" src="@/assets/campDetail/u1.jpg" alt="">
            <a class="connact-report" href="javascript:void(0)" @mouseenter="showLogo = true"  @mouseleave="showLogo = false">联系报名</a>
            <img v-show="showLogo" src="@/assets/common/logo.png" alt="" class="logo-i">
          </i-col>
          <i-col span="10">
            <h6>营员将学习什么</h6>
            <ul>
              <li>机器人基础机械结构</li>
              <li>在慧编程软件进行基础编程</li>
              <li>利用编程控制机器人</li>
              <li>机械及程序问题解决能力</li>
              <li>基础电脑使用技能</li>
            </ul>
            <h6>营员将收获什么</h6>
            <ul>
              <li>拥有个人特色的赛道机器人</li>
              <li>独特的实用性编程思维</li>
              <li>自主发现问题和调试的能力</li>
              <li>与团队讨论及共同展示作品</li>
            </ul>
          </i-col>
        </Row>
      </div>
      <div class="state">
        <p class="item-title">营地情况</p>
        <p class="small-title">坐落于主峰山下，得天独厚的自然条件和地理环境</p>
        <Row class="word-content2" type="flex" justify="center">
          <i-col span="10">
            <h1>清远田野绿世界（参考）</h1>
            <p>置身于佛冈田野绿世界，可以领略台湾民俗风情，品尝地道台湾美食，体验果园摘果乐趣，享受露营烧烤钓鱼的快乐。</p>
            <p>在不同季节您也可感受樱花之灿烂纯洁，兰花之清幽高洁，莲花之高风亮节，枫树之恬淡静美。在园区你还可以体验到各种乐趣，如捉萤火虫、捕蝴蝶、捞小鱼等等。</p>
            <p>想体验休闲活动可以去温室区,天鹅湖，抓溪鱼，湖滨步道；体验户外活动则有脚踏车、牛车步道；至于果园各种水果，更是选自原生态，美味可口，香醇甜美。</p>
          </i-col>
          <i-col span="12">
            <img src="@/assets/campDetail/u2.jpg" alt="">
          </i-col>
        </Row>
      </div>
      <div class="wd">
        <p class="item-title">为什么选择少儿编程</p>
        <p class="small-title">教育第一，技术第二</p>
        <Row class="tip">
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci1"></svg-icon>
            </div>
            <p>充满激情的导师</p>
            <p class="small-tip">导师团队由毕业于国内外顶尖大学高校热衷营地教育与STEAM创客科技的教育者组成</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci2"></svg-icon>
            </div>
            <p>劳逸结合的活动</p>
            <p class="small-tip">营地活动除了STEAM创客科技，还融合自然户外、人文文化等元素</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci3"></svg-icon>
            </div>
            <p>STEAM综合性设计</p>
            <p class="small-tip">活动课程设计沿用前沿的STEAM教学模式，引导营员自我思考和改进等能力</p>
          </i-col>
          <i-col span="6">
            <div class="ci">
              <svg-icon icon-class="ci4"></svg-icon>
            </div>
            <p>营地安全保障体系</p>
            <p class="small-tip">选择半/全封闭的营地环境，并在营地内配备相应医疗急救员及医疗设施</p>
          </i-col>
        </Row>
      </div>
    </div>
    <div class="footer-content">
      <div class="logo">
        <img src="@/assets/logo_white.png"
             alt="" />
      </div>
      <p class="item-title">少儿编程STEAM创客夏冬令营</p>
      <p class="small-title">适合6~18岁青少年的STEAM创客主题营</p>
      <p class="large-title">
        "我的孩子非常喜欢少儿编程的夏冬令营。他开始变得更外向，
        <br />
        更愿意和别人合作。谢谢你们营地工作人员的设计和照顾。“
      </p>
      <p class="name">伊隆·马斯克</p>
      <p class="small-title">少儿编程STEAM创客夏冬营营员家长</p>
    </div>
    <div class="fix-camp">
      <router-link to="/outside-camp">国外营地</router-link>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      type: "preWeek",
      showIndex: '',
      showLogo: false
    };
  },
  created () {
  },
  methods: {
    toDetail (workId) {
      this.$router.push({
        path: `/task-detail?workId=${workId}`
      });
    },
    toFriend (userId) {
      this.$router.push({
        path: `/friends?userId=${userId}`
      });
    }
  }
};
</script>
<style lang="scss">
.require .ivu-card-shadow {
  box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
  .ivu-card-body {
    padding: 0;
  }
}
</style>
<style lang="scss" scoped>
.camp {
  color: #333;
  position: relative;
  overflow: hidden;
  width: 100%;
  margin-top: -80px;
  padding-top: 80px;
  background: #fff;
  .top-content {
    height: 712px;
    margin-top: -80px;
    padding-top: 80px;
    background: linear-gradient(
      180deg,
      rgba(111, 134, 214, 1) 7%,
      rgba(77, 188, 235, 1) 100%
    );
    .wdd {
      width: 1500px;
      margin: 0 auto;
      position: relative;
      .top-tip {
        background-color: rgba(130, 202, 109, 1);
        height: 74px;
        font-size: 28px;
        color: #fff;
        line-height: 74px;
      }
      .carousel {
        width: 1197px;
        margin: 0 auto;
        position: relative;
        height: 566px;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.35);
        img{
          width: 100%;
          z-index: 9999;
          position: relative;
        }
        .word{
          position: absolute;
          top: 0;
          left: 0;
          z-index: 9999;
          width: 1197px;
          color: #fff;
          padding-top: 80px;
          background-color: rgba(0, 0, 0, 0.1);
          h1{
            font-size: 100px;
            font-weight: 700;
          }
          h3{
            font-size: 70px;
          }
          .msg{
            line-height: 70px;
            background: #81ca6c;
            color: #333;
            font-weight: 700;
            font-size: 30px;
            margin-top: 162px;
          }
        }
      }
    }
  }
  .explain {
    font-size: 0;
    position: absolute;
    left: -394px;
    top: 608px;
    z-index: 999;
    .wave {
      width: 2440px;
      height: 104px;
    }
  }
  .connact-report{
    text-align: center;
    margin-top: 40px;
    width: 173px;
    height: 61px;
    line-height: 61px;
    background: #70b600;
    color: #fff;
    font-size: 25px;
    font-weight: 700;
    display: inline-block;
    padding: 0 6px;
    border-radius: 10px;
    margin-right: 20px;
    &:hover{
      background: #444;
    }
  }
  .logo-i{
    width: 166px;
    position: absolute;
    bottom: -70px;
    left: 49%;
    transform: translateX(-50%);
  }
  .item-title {
    margin: 60px 0 30px;
    font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
    font-weight: 700;
    font-size: 40px;
  }
  .small-title {
    font-size: 25px;
    max-width: 990px;
    margin: 0 auto;
  }
  #basic_usage {
    margin-top: -40px;
    .world{
      background: rgba(242, 242, 242, 1);
      padding-top: 130px;
      padding-bottom: 40px;
    }
    .word-content{
      iframe{
        width: 521px;
        height: 346px;
        border: 1px solid #ddd;
      }
      h1{
        width: 500px;
        font-size: 40px;
      }
      p{
        width: 500px;
        font-size: 20px;
        margin-top: 30px;
      }
      .logo-i{
        bottom: -180px;
      }
    }
    .state{
      background: rgba(242, 242, 242, 1);
      padding: 10px 0 60px;
      .word-content2{
        margin-top: 60px;
        h1{
          font-size: 40px;
        }
        img{
          width: 551px;
          height: 735px;
        }
        p{
          font-size: 20px;
          line-height: 2.5;
          margin-top: 50px;
        }
      }
    }
    
    .logo {
      background: #70b603;
      width: 93px;
      height: 93px;
      border-radius: 50%;
      margin: 30px auto 0;
      text-align: center;
      position: relative;
      z-index: 1000;
      img {
        width: 55px;
        height: 55px;
        margin-top: 19px;
      }
    }
    .introduce{
      margin-top: 50px;
      font-size: 20px;
      color: #333;
    }
    .course-msg {
      margin-top: 50px;
      text-align: left;
      h6{
        font-size: 40px;
      }
      .u1{
        width: 566px;
        height: 424px;
      }
      ul{
        margin: 40px 0;
        li{
          list-style: disc;
          margin-left: 68px;
          font-size: 20px;
          line-height: 40px;
        }
      }
    }
    .tip {
      width: 1200px;
      margin: 0 auto;
      padding-bottom: 60px;
      p {
        font-size: 28px;
        font-weight: 700;
        &.small-tip{
          font-size: 20px;
          font-weight: 400;
          width: 230px;
          margin: 15px auto 0;
        }
      }
      span {
        font-size: 18px;
        display: block;
        width: 86%;
        margin: 0 auto;
        margin-top: 20px;
      }
      .circle {
        background: #fff;
        border-radius: 50%;
        box-shadow: 0px 0px 5px rgba(202, 222, 230, 0.407843);
        width: 50%;
        margin: 0 auto;
        padding: 15px 0;
        margin-bottom: 20px;
        height: 140px;
      }
      .circle-svg {
        width: 217px;
        height: 217px;
        svg {
          width: 100%;
          height: 100%;
        }
      }
      img {
        width: 103px;
      }
    }

    .ci{
      svg{
        width: 217px;
        height: 217px;
      }
    }
  }

  .footer-content {
    color: #fff;
    background: linear-gradient(
      180deg,
      rgba(53, 232, 150, 1) -117%,
      rgba(105, 103, 206, 1) 96%
    );
    background-size: 100% 140%;
    padding-top: 60px;
    padding-bottom: 100px;
    .large-title {
      margin-top: 40px;
      margin-bottom: 70px;
      font-size: 40px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      line-height: 50px;
    }
    .name {
      margin-bottom: 30px;
      font-family: "Rockwell Bold", "Rockwell Regular", "Rockwell", sans-serif;
      font-weight: 700;
      font-size: 25px;
    }
    .logo {
      margin: 0 auto;
      width: 93px;
      height: 93px;
      border-radius: 50%;
      background: #70b603;
      padding-top: 14px;
      img {
        width: 57px;
        height: 60px;
      }
    }
  }

  .fix-camp{
    position: fixed;
    bottom: 100px;
    left: 50px;
    z-index: 9999;
    a{
      color: #fff;
      font-size: 25px;
      width: 68px;
      display: block;
      padding: 10px;
      border-radius: 30px;
      background:rgba(130, 202, 109, 1);
      &:hover{
        background: #444;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/campDetail.vue